import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import './index.css';
import './style/map.css';
import './style/header.css';
import './style/sidebar.css';
import './style/databar.css';
import './style/filters.css';
import './app.css';
import "leaflet/dist/leaflet.css";
import App from './app';
import "@pmi/nyx-design-system/style.css";
import { Theme } from "@pmi/nyx-design-system";
import { SidebarProvider } from './context/sidebarcontext';
import { WindowProvider } from './context/filterscontext';
import { MapProvider } from './context/mapviewcontext';
import { ApiProvider } from './context/apicontext';

//Root file and set context provider
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Theme>
      <ApiProvider>
        <MapProvider>
          <SidebarProvider>
            <WindowProvider>
              <App />
            </WindowProvider>
          </SidebarProvider>
        </MapProvider>
      </ApiProvider>
    </Theme>
  </Provider>
);